import React from "react"
import PropTypes from "prop-types"
import { HeroContainer, TextContainer, Column } from "./styled"

import { H2, VazirParagraph } from "../typography"

const FeatureText = ({ title, description, ctaText, titleType }) => {
  const innerTitle = titleType || H2

  return (
    <TextContainer>
      {React.createElement(innerTitle, null, title)}
      <VazirParagraph
        dangerouslySetInnerHTML={{ __html: description }}
      ></VazirParagraph>
      {ctaText && <button className="featureCta">{ctaText}</button>}
    </TextContainer>
  )
}

const FeatureHero = ({
  image: FeatureImage,
  title,
  description,
  ctaText,
  columns,
  titleType,
  margin,
  ...rest
}) => (
  <HeroContainer direction="vertical" margin={margin}>
    {columns.map((column, i) => (
      <Column span={column.span} key={`${column.type}_${i}`}>
        {column.type === "image" ? (
          <FeatureImage />
        ) : (
          <FeatureText
            title={title}
            description={description}
            ctaText={ctaText}
            titleType={titleType}
          />
        )}
      </Column>
    ))}
  </HeroContainer>
)

FeatureHero.propTypes = {
  image: PropTypes.func,
  title: PropTypes.string,
  titleType: PropTypes.object,
  description: PropTypes.string,
  ctaText: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      span: PropTypes.number,
      type: PropTypes.oneOf(["image", "text"]),
    })
  ),
}

export default FeatureHero
